import type {DataCloudConfiguration, SalesforceConsent, SalesforceInteractionsSDK} from './types'

export const DATA_CLOUD_SCRIPT_ID = 'SalesforceInteractionsScript'

let sdkPromise: Promise<SalesforceInteractionsSDK> | null = null

export const isDataCloudConfigured = (config?: DataCloudConfiguration | null) =>
  Boolean(config?.enabled && config.scriptUrl?.startsWith('https://'))

const getSdk = () => window.getSalesforceInteractions?.() ?? window.SalesforceInteractions

const injectScript = (src: string) =>
  new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.id = DATA_CLOUD_SCRIPT_ID
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load ${src}`))
    document.head.appendChild(script)
  })

export const loadDataCloudSdk = (
  config: DataCloudConfiguration,
  initialConsents: SalesforceConsent[]
): Promise<SalesforceInteractionsSDK> => {
  if (sdkPromise) return sdkPromise

  sdkPromise = injectScript(config.scriptUrl).then(async () => {
    const sdk = getSdk()
    if (!sdk) throw new Error('SalesforceInteractions is not available after script load')
    sdk.setLoggingLevel(config.logLevel || 'none')
    await sdk.init({
      consents: initialConsents,
      ...(config.cookieDomain ? {cookieDomain: config.cookieDomain} : {})
    })
    return sdk
  })
  return sdkPromise
}

export const resetDataCloudLoader = () => {
  sdkPromise = null
}
